<template>
  <div class="register">
    <div class="login-user">
      <span class="bt">手机号</span>
      <input type="number" v-model="username" placeholder="请输入手机号" placeholder-class="placeholder_class" />
    </div>
    <div class="login-user">
      <span class="bt">密码</span>
      <input type="password" v-model="password" placeholder="请设置登录密码" placeholder-class="placeholder_class" />
    </div>
    <div class="login-user">
      <span class="bt">验证码</span>
      <input type="number" v-model="code" placeholder="请输入验证码" placeholder-class="placeholder_class" />
      <button class="code-btn" :disabled="disabled" @click="sendCode">{{ codeMsg }}</button>
    </div>
    <div class="login-btn" @click="register">注册</div>
    <!-- <div class="agree">
      <span class="chk" :class="isChecked ? 'active' : ''" @click="toggleCheck"></span>
      我已经阅读并同意<span class="f-active-color" @click="viewContract()">《用户注册协议》</span>
    </div> -->
  </div>
</template>
<script>
import $http from "@/common/api/request.js"
import {getQueryString} from "@/common/comm.js"
export default {
  data() {
    return {
      isChecked: true,
      codeNum: 60,
      codeMsg: "获取验证码",
      disabled: false,
      username: "",
      password: "",
      openId: "",
      serviceManagerId: '',
      code: ""
    }
  },
  mounted() {
    document.title = '注册'
    let request = getQueryString()
		this.serviceManagerId = request["serviceManagerId"]
    // console.log("this.serviceManagerId:", this.serviceManagerId)
    if (window.__wxjs_environment === 'miniprogram') {
      this.openId = request["openId"]
      // console.log("this.openId:", this.openId)
    }
  },
  methods: {
    register() {
      if (!this.validate()) return;
      let params = {
        url: '/sys/user/register',
        data: {
          username: this.username,
          password: this.password,
          openId: this.openId,
          serviceManagerId: this.serviceManagerId,
          code: this.code
        },
        method: 'POST'
      }
      $http.request(params).then(res => {
        if (res.code == 200) {
          alert('注册成功,请安装风易算小程序体验！')
        } else {
          alert(res.message)
        }
      })
    },
    validate() {
      if (this.username == '') {
        alert('手机号不能为空')
        return false
      } else {
        if (/^[1][3,4,5,6,7,8,9][0-9]{9}$/i.test(this.username) == false) {
          alert('手机号格式不正确')
          return false
        }
      }
      if (this.password == '') {
        alert('密码不能为空')
        return false
      }
      if (this.code == '') {
        alert('验证码不能为空')
        return false
      }
      return true
    },
    sendCode() {
      if (this.username == '') {
        alert('手机号不能为空')
        return
      }
      if (/^[1][3,4,5,6,7,8,9][0-9]{9}$/i.test(this.username) == false) {
        alert('手机号格式不正确')
        return
      }
      this._getSMS()
    },
    _getSMS() {
      let params = {
        url: '/sys/sms?mobile=' + this.username + '&mode=1',
        method: 'GET',
        header: {
          'Content-Type': 'application/json'
        }
      }
      $http.request(params).then(res => {
        if (res.code == 200) {
          this.codeMsg = "重新发送 (" + this.codeNum + ")"
          this.disabled = true
          let timer = setInterval(() => {
            --this.codeNum
            this.codeMsg = "重新发送 (" + this.codeNum + ")"
          }, 1000)
          setTimeout(() => {
            clearInterval(timer)
            this.disabled = false
            this.codeNum = 60
            this.codeMsg = "获取验证码"
          }, this.codeNum * 1000)
        } else {
          alert(res.message)
        }
      })
    },
    toggleCheck() {
      this.isChecked = !this.isChecked
    },
    viewContract() {}
  }
}
</script>
<style scoped>
.register {
  padding: 50px 20px;
}

.login-user {
  display: flex;
  align-items: stretch;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
}

.login-user .bt {
  flex: 0 0 60px;
  color: #858585;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-user input {
  padding: 10px;
  font-size: 14px;
  flex: 1;
  outline: none;
}

.code-btn {
  white-space: nowrap;
  border-radius: 0 !important;
  border: 0 !important;
  color: #fff;
  font-size: 0.64rem;
  background-color: #F83244;
  text-align: center;
  margin-left: 3px;
  border: 0 !important;
}

.login-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background-color: #F83244;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  margin-top: 20px;
}

.agree {
  font-size: 12px;
  color: #C2C3C3;
  text-align: center;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.f-active-color {
  color: #F83244;
}

.agree .chk {
  width: 20px;
  height: 20px;
  background: url("../assets/checkbox_bg.jpg") no-repeat center;
  background-size: 100%;
  margin-right: 10px;
}

.agree .chk.active {
  width: 20px;
  height: 20px;
  background: url("../assets/checkbox_sel.jpg") no-repeat center;
  background-size: 100%;
  margin-right: 10px;
}
</style>